import { render, staticRenderFns } from "./packageUsageStatistics.vue?vue&type=template&id=6986d554&"
import script from "./packageUsageStatistics.vue?vue&type=script&lang=js&"
export * from "./packageUsageStatistics.vue?vue&type=script&lang=js&"
import style0 from "./packageUsageStatistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports